import { render } from "./index.vue?vue&type=template&id=1539dac2"
const script = {}

import exportComponent from "E:\\bjft\\bjft-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__